import { UserProfile as Profile } from 'oidc-client-ts';
import { UserProfile } from './loginSlice';

// TODO: Depending on your client subscriptions you may want to map
//       additional properties from the OAuth profile
export const mapUserProfile = ({
    sub,
    azp,
    given_name,
    family_name,
    name,
    locale,
    email,
    tenant,
    ...profile
}: Profile): UserProfile => ({
    sub,
    azp,
    givenName: given_name,
    familyName: family_name,
    name,
    locale,
    email,
    tenant: tenant as string | undefined,
    ...profile,
});
